// ProfileContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useMutation } from "react-query";
import cogoToast from "cogo-toast";
import { AddProfile, GetProfile } from "../../services/backendServices";
import "../user-pages/userpages.css";
export const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
    const [profileData, setProfileData] = useState(null);

    //Function to fetch profile data
    const fetchProfile = async () => {
        try {
            const res = await GetProfile();
            setProfileData(res.data);
        } catch (e) {
            console.error("Error fetching profile:", e);
        }
    };

    // Mutation to add a profile
    const addProfile = useMutation("AddProfile", (set_values) =>
        AddProfile(set_values)
            .then((res) => {
                if (res.status) {
                    cogoToast.success(res.msg || "Profile added successfully!", {
                        hideAfter: 3,
                    });
                    setProfileData(res.data); // Update profile data with the newly added profile
                    fetchProfile();
                    return res;
                } else {
                    cogoToast.error(res.msg || "Failed to add profile", { hideAfter: 3 });
                    return false;
                }
            })
            .catch((e) => {
                console.log(e);
                console.log({ show: true, res: e });
            })
    );
    // Fetch the profile only if it's not already available
    useEffect(() => {
        if (!profileData) {
            fetchProfile();
        }
    }, []);
    // Function to update Prfile Data from the frontend
    const updateProfileData = (updateData) => {
        setProfileData((prev) => ({
            ...prev, ...updateData,
        }));
    };
    // The ProfileContext.Provider provides the profile data and the addProfile function to the rest of the application
    return (
        <ProfileContext.Provider value={{ profileData, addProfile, fetchProfile , updateProfileData }}>
            {children}
        </ProfileContext.Provider>
    );
};

// Custom hook to access profile data and addProfile function
export const useProfile = () => useContext(ProfileContext);
